/**
 * @fileoverview Agent definition for the chapter-boundary-detector-v1 primitive.
 *
 * Identifies chapter boundaries in a document — headings, first/last lines,
 * and titles — without extracting rich metadata (keyEvents, scenes, etc.).
 * This is step 1 of the human-gated extraction workflow: detect boundaries,
 * let the user review/edit, then extract metadata and content.
 *
 * @category import.story.extraction
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas/agent';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'chapter-boundary-detector-v1',
  kind: 'primitive',
  name: 'Chapter Boundary Detector',
  description: 'Identifies chapter boundaries (headings, first/last lines, titles) in a document. Designed as step 1 of human-gated extraction.',
  category: 'import',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-03',
    lastUpdated: '2026-03',
    taxonomyPath: 'import.story.extraction',
    usedBy: ['use-robust-chapter-extraction-workflow-v1.ts'],
    relatedAgents: ['chapter-extractor-v2', 'chapter-metadata-extractor-v1', 'robust-chapter-formatter-v1'],
  },
};
